"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CarSpecificExcessWidget = void 0;
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var ExcessExplainedRenderers_1 = require("../../../components/modals/renderers/ExcessExplainedRenderers");
var InfoModal_1 = require("../../../components/modals/InfoModal");
var CommonRenderers_1 = require("../../../helpers/CommonRenderers");
var commonFunctions_1 = require("../../../commonFunctions");
var Types_1 = require("../../../Types");
var core_1 = require("@athena-portal/core");
var React = require("react");
var CarSpecificExcessWidget = exports.CarSpecificExcessWidget = /** @class */ (function (_super) {
    __extends(CarSpecificExcessWidget, _super);
    function CarSpecificExcessWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.vehicleIndex = (0, commonFunctions_1.getIndexSetting)("vehicleIndex", _this.getSetting("vehicleIndex", undefined), _this.props.question.type);
        var vehicle = _this.bindFromField("vehicles[".concat(_this.vehicleIndex, "]"));
        _this.state = {
            vehicle: vehicle
        };
        _this.renderExcesses = _this.renderExcesses.bind(_this);
        _this.handleVoluntaryExcessChange = _this.handleVoluntaryExcessChange.bind(_this);
        return _this;
    }
    CarSpecificExcessWidget.prototype.render = function () {
        return (React.createElement(React.Fragment, null, this.renderExcesses()));
    };
    CarSpecificExcessWidget.prototype.renderExcesses = function () {
        var interaction = this.props.engine.getInteraction();
        var vehicle = interaction.vehicles[this.vehicleIndex];
        return (React.createElement("div", { className: "panel" },
            React.createElement("div", { className: "text-center muli-bold-16-black pt-3 pb-3" }, "Excesses"),
            React.createElement("div", { className: "mb-3" },
                React.createElement("label", { className: "text-center pl-5 m-0" },
                    "Compulsory excess",
                    React.createElement(InfoModal_1.InfoModal, { className: "mb-2 ml-2", title: "Compulsory excess explained" }, (0, ExcessExplainedRenderers_1.renderCompulsoryExcessExplained)(vehicle.excesses))),
                (0, CommonRenderers_1.renderDriverCompulsoryExcess)(interaction, vehicle)),
            React.createElement("div", { className: "mb-3" },
                React.createElement("label", { className: "text-center pl-5 mb-3" },
                    "Voluntary excess",
                    React.createElement(InfoModal_1.InfoModal, { className: "mb-2 ml-2", title: "Voluntary excess explained" }, (0, ExcessExplainedRenderers_1.renderVoluntaryExcessExplained)(vehicle.excesses))),
                this.renderVoluntaryExcessBtns(vehicle))));
    };
    CarSpecificExcessWidget.prototype.renderVoluntaryExcessBtns = function (vehicle) {
        var _this = this;
        var excessAmounts = [0, 100, 200, 300, 400, 500];
        var btns = [];
        excessAmounts.forEach(function (amount, index) {
            var isChecked = amount === vehicle.excesses.voluntaryExcess;
            btns.push((React.createElement("div", { key: index, className: "col-4 mb-3" },
                React.createElement("div", { className: "btn-radio mx-2" },
                    React.createElement("input", { id: "excess".concat(vehicle.registrationNumber, "amount").concat(amount), name: "excess".concat(vehicle.registrationNumber), type: "radio", value: amount, "data-vehicle-index": vehicle.info.index, onChange: _this.handleVoluntaryExcessChange, checked: isChecked }),
                    React.createElement("label", { htmlFor: "excess".concat(vehicle.registrationNumber, "amount").concat(amount) }, "\u00A3".concat(amount))))));
        });
        return (React.createElement("div", { className: "voluntary-excess-btns row no-gutters mx-auto" },
            btns,
            "            "));
    };
    CarSpecificExcessWidget.prototype.handleVoluntaryExcessChange = function (event) {
        var amount = parseInt(event.target.value);
        var vehicleIndex = event.target.dataset.vehicleIndex;
        this.props.onStateChange("vehicles[".concat(vehicleIndex, "].excesses.voluntaryExcess"), amount);
        this.executeEvent("change");
        this.changelogRecorder.record(this.props.engine.getInteraction(), "change", "vehicles[".concat(vehicleIndex, "].excesses.voluntaryExcess"), this.props.page && this.props.page.pageId);
    };
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.ChangelogRecorder),
        __metadata("design:type", Object)
    ], CarSpecificExcessWidget.prototype, "changelogRecorder", void 0);
    return CarSpecificExcessWidget;
}(plugin_journey_1.WidgetBase));
//# sourceMappingURL=CarSpecificExcessWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/subscription/motor/CarSpecificExcessWidget.js
// module id = 2594
// module chunks = 0